<div class="wrapper">
  <app-navbar></app-navbar>
  <app-contact-form></app-contact-form>
  <app-start-trading></app-start-trading>
  <app-footer></app-footer>
</div>
